import { render, staticRenderFns } from "./TableRows.vue?vue&type=template&id=1bb63c8e&scoped=true"
import script from "./TableRows.vue?vue&type=script&lang=js"
export * from "./TableRows.vue?vue&type=script&lang=js"
import style0 from "./TableRows.vue?vue&type=style&index=0&id=1bb63c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb63c8e",
  null
  
)

export default component.exports